/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { IconInfoCircle, IconX } from "@tabler/icons-react";
import React from "react";

import Button, { ButtonProps, ButtonSize, ButtonType } from "../Button/Button";

export enum AlertLevel {
  info = "info",
  success = "success",
  warning = "warning",
  error = "error",
  default = "default",
}

const colors: Record<AlertLevel, string> = {
  [AlertLevel.info]: "bg-bg-information text-text-on-color",
  [AlertLevel.success]: "bg-bg-success text-text-on-color",
  [AlertLevel.warning]: "bg-bg-warning text-text-on-color",
  [AlertLevel.error]: "bg-bg-danger text-text-on-color",
  [AlertLevel.default]: "bg-bg-information text-text-on-color",
};

export interface AlertProps {
  title: string;
  description?: string;
  level?: AlertLevel | `${AlertLevel}`;
  icon?: React.ReactNode;

  // Dismissability
  dismissable?: boolean;
  dismissIcon?: React.ReactNode;
  onDismiss?: () => void;
  actions?: (Omit<ButtonProps, "type" | "children" | "size"> & {title: string})[];
}

// This is extremely similar to the Tooltip but is fundamentally different behaviour.
// Hence we will duplicate the code here.
const Alert: React.FC<AlertProps> = ({
  title,
  description,
  level = AlertLevel.default,
  icon,
  dismissable = false,
  dismissIcon,
  onDismiss,
  actions,
}) => (
  <div className="shadow-md rounded-lg">
    <div className={
      `flex items-center w-full p-3 gap-x-2 ${(description || actions?.length) ? "rounded-t-lg" : "rounded-lg"} ${colors[level]}`
    }
    >
      {icon ?? <IconInfoCircle />}
      <span className="typography-medium-base flex-1">{title}</span>
      {dismissable && (
        <span className="cursor-pointer" onClick={() => onDismiss()}>
          {dismissIcon || <IconX />}
        </span>
      )}
    </div>
    {(description || actions?.length) && (
      <div className="w-full px-3 py-4 rounded-b-lg bg-bg-subtle text-text-subtle typography-medium-base">
        {description}
        {!!actions?.length && (
          <div className={description ? "pt-2" : ""}>
            {actions?.map((props) => (
              <Button {...props} type={ButtonType.neutral} size={ButtonSize.small}>
                {props.title}
              </Button>
            ))}
          </div>
        )}
      </div>
    )}
  </div>
);

export default Alert;
